module.exports = __webpack_public_path__ + "img/image_three.b747115a.svg";